import { useEffect, useState } from 'react';
import { Alert, Modal, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEmailLogService } from '../../services/emailLogService';
import EmailBody from './EmailBody';

/** The body of one logged email, fetched when the modal opens; closed while emailId is null. */
export default function EmailBodyModal({ emailId, onClose }) {
    const { t } = useTranslation('emailLog');
    const { getEmailLogEntry } = useEmailLogService();
    const [state, setState] = useState({ email: null, failed: false });

    useEffect(() => {
        if (emailId === null) return undefined;
        let current = true;
        setState({ email: null, failed: false });
        getEmailLogEntry(emailId)
            .then(email => current && setState({ email, failed: false }))
            .catch(() => current && setState({ email: null, failed: true }));
        // the admin may close or open another email before this one arrives
        return () => {
            current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailId]);

    return (
        <Modal
            open={emailId !== null}
            onCancel={onClose}
            footer={null}
            width={800}
            title={state.email?.subject || t('bodyTitle')}
        >
            {state.failed && <Alert type="error" message={t('bodyLoadFailed')} />}
            {!state.failed && !state.email && <Spin />}
            {state.email && <EmailBody email={state.email} title={t('bodyTitle')} />}
        </Modal>
    );
}
